import Vue from "vue";

const self = Vue.prototype

export default {
    disableZoom() {
        if (self.$vuetify.breakpoint.smAndDown) {
            const metaViewport = document.querySelector('meta[name="viewport"]');
            metaViewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
        }
    }
}